'use client';

import { useTranslations } from 'next-intl';
import { Button } from '../Button/Button';
import { useAppNavigationDialog } from '@/components/features/AppNavigationDialog/useAppNavigationDialog';
import { makeTopDeepLink } from '@/utils/deeplink';

export function AppDownloadButton() {
  const t = useTranslations('common.appDownloadLeads');
  const { navigate, Dialog } = useAppNavigationDialog({ href: makeTopDeepLink() });
  const handleClick = () => {
    navigate();
  };

  return (
    <>
      <Button
        variant="filled"
        colorScheme="primary"
        size="small"
        className="flex-shrink-0"
        onClick={handleClick}
      >
        {t('downloadButton')}
      </Button>
      {Dialog}
    </>
  );
}
